export default "__VITE_ASSET__DRa5FJNy__"